import { ApiClientProps } from "hooks/useApi";


export interface CRMItem {
    crmName: string;
    crmLocationId: string;
    enabled: boolean;
}

export interface CRMsResponse {
    hasErrors: boolean;
    message: string;
    resource: CRMItem[];
}

interface GetCRMsProps {
    locationId?: string;
    partnerId: string | undefined;
    posType: string | null | undefined;
    apiClient: ApiClientProps;
}

const getCRMs = async ({
  locationId,
  partnerId,
  posType,
  apiClient
}: GetCRMsProps): Promise<CRMItem[]> => {
    if (!locationId || !posType || !partnerId) {
        throw new Error("Missing required parameters to fetch CRMs.");
    }

      const  response = await apiClient.get({
        path: `/middleware-admin/partners/${partnerId}/locations/${locationId}/crms`,
        noRetry: true,
      });

    return response;
};

export default getCRMs;
